import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Components
import { SvgList, NavBar, Button } from '../../components';

// Images
import Settings from '../../assets/Settings.png';

// Styles
import './SearchSongs.scss';
import { formatDateToDisplay } from '../../utils';
import { songActions } from '../../actions';
import { CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Popup from '../../components/Popup';
import SearchBox from '../../components/SearchBox';
import { toCamelCase } from '../../utils/generalUtils';
import Dropdown from '../../components/Dropdown';
import { SONGS } from '../../constants';
import { size } from 'lodash';

function SearchSong() {
  const refference = useRef(true);
  const LIMIT = 50;
  const history = useHistory();

  const [currentPage, setCurrentPage] = useState({ page: 1, isLast: false });
  const [deletePopUp, setDeletePopUp] = useState({ isOpen: false, id: null });

  const [isLoading, setIsLoading] = useState(true);
  const [songs, setSongs] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [songFilterStatus, setSongsFilterStatus] = useState({ label: 'All', value: 'ALL' });
  const [isFetchingMore, setIsFetchingMore] = useState(false);

  const gridRef = useRef(null);

  const fetchMoreSongs = async () => {
    if (isFetchingMore || currentPage.isLast || isLoading) return;

    const filterToPass = songFilterStatus?.value === 'ALL' ? ['ADMIN', 'ARTIST'] : [songFilterStatus?.value];
    setIsFetchingMore(true);
    const songsFromBE = await songActions.fetchAllSongs({
      page: currentPage.page + 1,
      limit: LIMIT,
      submission_status: 'ACCEPTED',
      search: searchInput,
      status: 'ACTIVE',
      created_by: filterToPass,
    });
    setSongs((prev) => [...prev, ...songsFromBE]);
    setIsFetchingMore(false);
    setCurrentPage((prev) => ({
      page: prev.page + 1,
      isLast: size(songsFromBE) < LIMIT,
    }));
  };

  // Detect When user scroll to bottom of table
  const handleScroll = (e) => {
    // detect when scrolled to bottom before reaching bottom by 20px
    const bottom = e.target.scrollHeight - e.target.scrollTop - 20 <= e.target.clientHeight;
    if (bottom && !currentPage.isLast) {
      fetchMoreSongs();
    }
  };

  // Handle Delete Song
  const handleDeleteSong = async () => {
    setIsLoading(true);
    try {
      const deleteSongres = await songActions.deleteSong(deletePopUp.id);
      if (deleteSongres) {
        setSongs(songs.filter((item) => item.id !== deletePopUp.id));
        setDeletePopUp({ isOpen: false, id: null });
        setIsLoading(false);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleSearchInputChange = (searchVal) => {
    setSearchInput(searchVal);
  };

  useEffect(() => {
    if (!refference.current) {
      refference.current = false;
      return;
    }

    (async () => {
      // scroll to top of table
      gridRef.current?.scrollTo(0, 0);

      const filterToPass = songFilterStatus?.value === 'ALL' ? ['ADMIN', 'ARTIST'] : [songFilterStatus?.value];
      setIsLoading(true);
      const songsFromBE = await songActions.fetchAllSongs({
        page: 1,
        limit: LIMIT,
        submission_status: 'ACCEPTED',
        search: searchInput,
        status: 'ACTIVE',
        created_by: filterToPass,
      });

      setSongs(songsFromBE);
      setIsLoading(false);
      setCurrentPage({ page: 1, isLast: false });
    })();
  }, [searchInput, songFilterStatus]);

  return (
    <>
      <NavBar data="Search song" icon={Settings} currentRouteName="Search song" breadcrumbsPath={[{ name: 'Songs' }]} />
      <div className="content" style={{ marginTop: 73 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <SearchBox placeholder="Search Song here..." onChange={(e) => handleSearchInputChange(e)} />
          <Dropdown value={songFilterStatus} setValue={setSongsFilterStatus} options={SONGS.SONGS} />
        </div>

        <div style={{ display: 'flex', height: '100%', overflow: 'hidden', flex: 1, width: '100%' }}>
          <TableContainer ref={gridRef} className="tbl_wraper tbl_wrap" component={Paper} onScroll={handleScroll}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell className="table_font result">Result</TableCell>
                  <TableCell className="table_font">Name</TableCell>
                  <TableCell className="table_font">Date</TableCell>
                  <TableCell className="table_font">Plan</TableCell>
                  <TableCell className="table_font">Uploaded By</TableCell>
                  <TableCell className="table_font action">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && (
                  <div className="table_initial_loader">
                    <CircularProgress />
                  </div>
                )}
                {songs?.length === 0 && !isLoading ? (
                  <div className="table_initial_loader">
                    <h4
                      style={{
                        textAlign: 'center',
                        marginBottom: 20,
                        fontSize: 20,
                        lineHeight: '32px',
                        maxWidth: '60%',
                        marginInline: 'auto',
                      }}
                    >
                      No Songs Found
                    </h4>
                  </div>
                ) : (
                  songs?.map((row, index) => (
                    <TableRow key={row.id} style={{ cursor: 'pointer' }} onClick={() => history.push(`/songs/song-detail?id=${row.id}`)}>
                      <TableCell className="table-index-cell result">#{++index}</TableCell>
                      <TableCell className="table-name-cell">{row.title}</TableCell>
                      <TableCell>{formatDateToDisplay(row.created_at)}</TableCell>
                      <TableCell>{row.plan.map((item) => toCamelCase(item)).join(', ')}</TableCell>
                      <TableCell>{toCamelCase(row.created_by)}</TableCell>
                      <TableCell className="action">
                        <div
                          style={{ display: 'flex', columnGap: 15, alignItems: 'center' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setDeletePopUp({ isOpen: true, id: row.id });
                          }}
                        >
                          <div style={{ cursor: 'pointer' }}>
                            <SvgList name="cancel-icon" />
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
                {isFetchingMore && (
                  <TableRow className="fetch_more_loader">
                    <CircularProgress />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>

      <Popup open={deletePopUp?.isOpen} onClose={() => !isLoading && setDeletePopUp({ isOpen: false, id: null })}>
        <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
          Are you sure, you want to delete this song?
        </h4>
        <div className="button-group" style={{ '--button-color': '#6900af' }}>
          <Button onClick={() => !isLoading && setDeletePopUp({ isOpen: false, id: null })} className="button transparent">
            Cancel
          </Button>
          <Button isLoading={isLoading} onClick={handleDeleteSong} className="button primary">
            Confirm
          </Button>
        </div>
      </Popup>
    </>
  );
}
export default SearchSong;

